/** Keeps every open tab in step: signing out in one tab signs out all of them. */
const CHANNEL = 'cd-auth';
const SIGNED_OUT = 'signed-out';

function channel(): BroadcastChannel | null {
  return typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel(CHANNEL);
}

export function announceSignedOut(): void {
  const ch = channel();
  ch?.postMessage(SIGNED_OUT);
  ch?.close();
}

export function onSignedOutElsewhere(handler: () => void): () => void {
  const ch = channel();
  if (!ch) return () => undefined;
  ch.onmessage = (event: MessageEvent<unknown>) => {
    if (event.data === SIGNED_OUT) handler();
  };
  return () => {
    ch.close();
  };
}
